<template>
  <v-container>
    <v-card>
      <v-layout :column="$vuetify.breakpoint.xsOnly" py-3>
        <v-flex xs12 md2>
          <v-layout column fill-height align-center justify-center>
            <v-avatar color="primary" size="120">
              <v-icon dark large>account_circle</v-icon>
            </v-avatar>
          </v-layout>
        </v-flex>
        <v-flex xs12 md10>
          <v-card-title primary-title>
            <div>
              <div class="headline">
                {{ usuario.Colaborador }}
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn fab small icon v-on="on" @click="modalUsuario = true">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Alterar Usuário</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn fab small icon v-on="on" @click="dialogSenha = true">
                      <v-icon>lock</v-icon>
                    </v-btn>
                  </template>
                  <span>Alterar Senha</span>
                </v-tooltip>
              </div>
              <div>{{ usuario.Email }}</div>
              <div>{{ usuario.Perfil }}</div>
            </div>
          </v-card-title>
        </v-flex>
      </v-layout>
    </v-card>
    <ModalCadastroUsuario 
      v-model="modalUsuario"
      :usuario="usuario"
    />
    <ModalSetaSenha 
      v-model="dialogSenha"
      :usuario="usuario"
      :loading="loading"
      @setaSenhaSelected="alteraSenhaUsuario"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ModalCadastroUsuario from '@/components/usuario/ModalCadastroUsuario';
import ModalSetaSenha from '@/components/usuario/ModalSetaSenha';
import Usuario from '@/domain/usuario/Usuario';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'UsuarioPerfil',
  data: () => ({
    loading: false,
    modalUsuario: false,
    usuario: new Usuario(),
    dialogSenha: false,
  }),
  components: {
    ModalCadastroUsuario,
    ModalSetaSenha,
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    ...mapActions(['fetchUsuarioPorId', 'atualizaSenhaUsuario']),
    ...mapMutations(['showNotification']),
    async inicializaUsuario() {
      const id = this.$route.params.id;
      if (id != this.user.IdUsuario) {
        this.showNotification({ text: 'Usuário inválido, redirecionando para Home.', status: 'error' });
        this.$router.replace('/');
      } else {
        [this.usuario] = await this.fetchUsuarioPorId(this.user.IdUsuario);
      }
    },
    async alteraSenhaUsuario(payload) {
      this.loading = true;
      const res = await this.atualizaSenhaUsuario(payload);
      if (res) {
        this.dialogSenha = false;
        this.loading = false;
        this.showNotification({ text: 'Senha alterada com sucesso.', status: 'success' });
      } else {
        this.loading = false;
        this.showNotification({ text: 'Senha atual inválida.', status: 'error' });
      }
    }
  },
  created() {
    changePageTitle('Perfil');
    this.inicializaUsuario();
  }
}
</script>

<style>

</style>